import { toTitleCase } from '@/utils/commonUtils';
import { EVENT_TYPES } from '@/utils/eventPage/constants';

export const formatEventLocation = (walk) => {
    return [walk?.city_name, walk?.state_name, walk?.country_name]
        .filter(Boolean)
        .map((item) => toTitleCase(item))
        .join(', ');
};

export const getEventDetailsRoute = (type, id) => {
    if (type === EVENT_TYPES.groupWalks) {
        return `/group-walk/${id}`;
    }

    return `/walk/${id}`;
};

export const isGroupWalkType = (type) => type === EVENT_TYPES.groupWalks;
